<template>
    <VPage>
        <VPageHeader show-third-block :title="pageTitle">
            <template v-slot:second>
                <div class="app-page-header__column app-page-header__column--tools">
                    <VFilterPopup v-model="customFilters" class="prevent-close" :options="filterOptions"></VFilterPopup>

                    <VButtonDropdown
                        class="prevent-close"
                        :options="pageActions"
                        placement="left-start"
                        v-if="pageActions.length"
                    >
                        <DotsSvg class="rotate-90"></DotsSvg>
                    </VButtonDropdown>

                    <VSearchField v-model="searchString" class="prevent-close" debounce-mode></VSearchField>
                </div>
            </template>
        </VPageHeader>

        <VPageContent vertical>
            <NumericsWidget :filters="filters" widget-page widget-secondary></NumericsWidget>
        </VPageContent>
    </VPage>
</template>

<script setup lang="ts">
// Svg
import DotsSvg from '@/assets/dots.svg';

// Components
import VSearchField from '../components/VSearchField.vue';
import VFilterPopup from '../components/VFilterPopup.vue';
import VPage from '../components/VPage.vue';
import VPageHeader from '../components/VPageHeader.vue';
import VPageContent from '../components/VPageContent.vue';
import VButtonDropdown from '../components/VButtonDropdown.vue';

// Widgets
import NumericsWidget from '../widgets/NumericsWidget.vue';

// Other
import { useI18n } from 'vue-i18n';
import { onMounted } from 'vue';
import { IDropdownOption } from '@/core/Values/IDropdownOption';
import { setPageTitle } from '@/utils/document-utils';
import { useNumericFilters } from '@/mixins/NumericApi';

const { t } = useI18n();
const { filters, searchString, filterOptionsNamed, customFilters } = useNumericFilters('numerics.list', {}, {});
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const filterOptions = Object.values(filterOptionsNamed);

let pageTitle = t('numerics-list');
let pageActions: IDropdownOption[] = [];

onMounted(() => {
    setPageTitle(pageTitle);
});
</script>
